import CitySEOHead from "@/components/feature/CitySEOHead";
import CookevilleHeroSection from "./components/HeroSection";
import CookevilleStickyNav from "./components/StickyNav";
import CookevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import CookevilleFAQSection, { faqs } from "./components/FAQSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { cookevilleConfig } from "./data";

export default function CookevillePage() {
  const c = cookevilleConfig;
  return (
    <>
      <CitySEOHead
        city="Cookeville"
        state="Tennessee"
        stateAbbr="TN"
        route="/cookeville"
        title="Emergency Passport Cookeville, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Cookeville, TN — as fast as 24 hours. A+ BBB rated registered courier serving Tennessee Tech, Cookeville Regional Medical, and all Upper Cumberland. No Nashville drive required."
        geoPlacename="Cookeville, Tennessee"
        geoPosition="36.1628;-85.5016"
        faqs={faqs}
        servicesSchema={c.servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <div className="font-sans">
        <CookevilleHeroSection />
        <CookevilleStickyNav />
        <CookevilleProcessingTimeSection />
        <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
        <CityLocalAreaSection city={c.city} state={c.state} cities={c.nearbyCitiesZips} benefits={c.benefits} internalLinks={c.internalLinks} officeNote={c.fpcOfficeNote} officeDistance={c.fpcOfficeDistance} officeAddress={c.fpcOfficeAddress} serviceAreaIntro={c.serviceAreaIntro} nearbyCitiesIntro={c.nearbyCitiesIntro} />
        {c.travelTiming && <CityTravelTimingSection city={c.city} data={c.travelTiming} />}
        {c.destinations && <CityDestinationsSection city={c.city} data={c.destinations} />}
        <CityTestimonialsSection city={c.city} testimonials={c.testimonials} intro={c.testimonialsIntro} />
        <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
        <CityComparisonSection city={c.city} regionalAgency={c.regionalAgency} rows={c.comparisonRows} />
        <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
        <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
        <CookevilleFAQSection />
        <CityHelpfulResourcesSection city={c.city} state={c.state} photoLocations={c.photoLocations} dmvLocations={c.dmvLocations} airports={c.airports} dmvWebsite={c.dmvWebsite} dmvLabel={c.dmvLabel} vitalRecordsLinks={c.vitalRecordsLinks} />
        <SEOCrossLinks currentRoute="/cities/cookeville" state="TN" />
        <CityFinalCTA />
      </div>
    </>
  );
}